import React, { useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { injectIntl } from "react-intl";

import "./style.less";

import { Button, Col, Row } from "antd";

import FullScreenNoticeLayout from "components/FullScreenNoticeLayout";

import T from "components/T";

const NotSubscribed = ({ organization, intl, auth }) => {
  const navigate = useNavigate();
  const t = intl.messages;

  const { logged_in } = auth || {};

  useEffect(() => {
    if (!logged_in) {
      return navigate("/signin", { replace: true });
    }
  }, [logged_in, navigate]);

  const handleLogout = useCallback(() => navigate("/logout"), [navigate]);

  return (
    <FullScreenNoticeLayout>
      <h2 className="NotSubscribed__title">{t.notsubscribed_title}</h2>
      <div className="NotSubscribed__desc">
        <T
          notsubscribed_desc={{
            organization_name: (organization.data || {}).name,
          }}
        />
      </div>
      <Row type="flex" gutter={8} className="NotSubscribed__buttons">
        <Col>
          <Button key="submit" type="default" onClick={handleLogout}>
            {t.notsubscribed_change_account}
          </Button>
        </Col>
      </Row>
    </FullScreenNoticeLayout>
  );
};

const mapStateToProps = ({ organization, auth }) => ({
  organization,
  auth,
});

export default injectIntl(connect(mapStateToProps)(NotSubscribed));
